export type ResponseError = Error & {
  status?: number;
};

export async function fetcher<T = any>(
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<T> {
  const response = await fetch(input, init);

  if (!response.ok) {
    const error = new Error(
      `An error occurred while fetching data: ${response.statusText}`
    ) as ResponseError;

    error.status = response?.status;
    throw error;
  }

  return (await response.json()) as T;
}
